<script setup lang="ts">
definePageMeta({
  layout: 'auth',
  title: 'forgotPassword.label',
  isPublicPage: true,
  isAuthPage: true,
})

const store = useUserStore()
const { trackError } = useErrorTracking()
const gtm = useGtm()

onMounted(() => {
  gtm?.trackEvent({ event: 'password_reset_start' })
})

// data
const isFormValid = ref(false)
const isLoading = ref(false)
const isFormSubmitted = ref(false)

const username = ref()

// validation
const emailRules = [
  useRequiredRule,
  (value: string) => useMaxLengthRule(value, 127),
  useEmailRule,
]

async function submit() {
  if (!isFormValid.value)
    return
  isLoading.value = true

  const isSucceed = await store.forgotPassword(username.value)
  if (isSucceed) {
    isFormSubmitted.value = true
  }
  else {
    trackError({ type: 'network', text: 'errors.forgotPassword.failed' })
  }
  isLoading.value = false
}
</script>

<template>
  <div class="d-flex justify-center align-center py-8">
    <div v-if="isFormSubmitted" class="d-flex justify-center align-center py-16">
      <v-card
        elevation="0"
        class="rounded-xl pa-16 d-flex flex-column justify-center"
        max-width="820"
        min-height="520"
      >
        <h1 class="mb-4 text-h3 text-center">
          {{ $t('thanks') }}
        </h1>
        <h2>
          {{ $t('forgotPassword.success.description') }}
        </h2>

        <v-container class="pa-0">
          <v-row justify="end" align="end">
            <v-col cols="auto" class="pa-6">
              <nuxt-picture
                src="/images/bird.svg"
                class="mr-16"
                width="98"
                height="auto"
                style="position: absolute; bottom: 0; right: 0; transform: scaleX(-1);"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </div>

    <v-card
      v-else
      elevation="0"
      class="rounded-xl pa-8 d-flex flex-column justify-center"
      width="820"
    >
      <h2 class="mb-6 font-weight-bold text-center">
        {{ $t('forgotPassword.label') }}
      </h2>

      <v-form v-model:model-value="isFormValid" class="mb-4 px-16" @submit.prevent="submit">
        <v-label :text="$t('email')" />
        <v-text-field-primary
          v-model="username"
          :rules="emailRules"
        />

        <div class="d-flex justify-center align-center">
          <v-btn-primary
            color="green-500"
            :loading="isLoading"
            type="submit"
            :text="$t('resetPassword.label')"
            class="font-weight-bold mt-8"
            data-track-id="forgot_password_submit"
          />
        </div>
      </v-form>
    </v-card>
  </div>
</template>
